import { EventCategory } from "@/types/ui";
import { FrameName } from "../config";
import EventTileEntity from "../EventTileEntity";

class HauntedMansionBuildingTileEntity extends EventTileEntity {
	public static readonly eventType = EventCategory.HALLOWEEN;

	public static readonly frameName = FrameName.HAUNTED_MANSION;
}

export default HauntedMansionBuildingTileEntity;
